import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { setTestModels } from '../actions/test-models.actions';
import { TestModel } from '../models/test-model.model';
import * as helpers from '../helpers/helpers';

export const initialState: TestModel[] = [];

const reducer = createReducer(initialState,
  on(setTestModels, (state, { testModels }) => testModels)
);

export const fromTestModels = {
  selectTestModelsState: createFeatureSelector<TestModel[]>('testModels'),

  selectTestModelsAlphabetically: createSelector(((state: { testModels: TestModel[] }) => state.testModels),
    (testModels: TestModel[]) => {
      const testModelsCopy = testModels.slice();
      const testModelsSort: TestModel[] = [testModelsCopy.shift(), testModelsCopy.shift()];
      return [...testModelsSort, ...testModelsCopy.sort((a, b) => helpers.alphabeticSort(a.name, b.name))];
    }
  ),
};

export function testModelsReducer(state, action) {
  return reducer(state, action);
}
